module.exports = __webpack_public_path__ + "kudos_66.svg?5e89eb2bb5a12fd3fcd052d9925dcd83";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_66.svg
// module id = 168
// module chunks = 0